import React from 'react';
import { string, bool } from 'prop-types';

import { SCMenuItem } from './styles';
import StatusIcon from './StatusIcon';

MenuItem.propTypes = {
  activeClassName: string,
  status: string,
  title: string.isRequired,
  to: string.isRequired,
  disabled: bool,
};

MenuItem.defaultProps = {
  activeClassName: 'active',
  status: null,
  disabled: false,
};

function MenuItem({ title, status, to, activeClassName, disabled }) {
  return (
    <SCMenuItem
      disabled={disabled}
      activeClassName={activeClassName}
      exact
      to={disabled ? '#' : to}>
      {title} <StatusIcon status={status} />
    </SCMenuItem>
  );
}

export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/Menu/MenuItem.js